import { Button, Container, makeStyles, TextField, Typography, IconButton, FormControl, InputLabel, Input, InputAdornment, MenuItem } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { useCookies } from 'react-cookie';
import { Visibility, VisibilityOff, Check } from '@material-ui/icons';

import { COLORS } from '../shared/Theme';
import ToastStr from '../request/toastStr';
import { oper as v_oper, basic, Values, SNACKBAR_TIME } from '../request/values';
import { SIcon } from '../shared/Icon';

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	back: {
		marginLeft: '-1vh',
	},
	container: {
		width: '82%',
		marginTop: '7vh',
		padding: 0,
	},
	paper: {
		// marginTop: theme.spacing(8),
		// width: '82%',
		margin: 'auto',
		display: 'flex',
		flexDirection: 'column',
	},
	title: {
		// width: '80%',
		alignItems: 'left',
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1),
	},
	submit: {
		height: 60,
		color: `${COLORS.WATER_BLUE}`,
		textColor: '#ffffff',
		margin: theme.spacing(3, 0, 2),
		borderRadius: '27px',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'solid 0.5px #cfd4d9',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			backgroundColor: `${COLORS.WATER_BLUE}`,
		},
	},
	selectField: {
		width: '100%',
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(2),
	},
	selectRoot: {
		'& .MuiFormLabel-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiSelect-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 12,
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#cfd4d9',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
			borderWidth: 2,
		},
	},
	selectLabel: {
		backgroundColor: '#fff',
		padding: '0 4px',
	},
	menuPaper: {
		borderRadius: 12,
		boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
		marginTop: 8,
	},
	menuItem: {
		...theme.typography.body1,
		padding: theme.spacing(1.25, 1.5),
		'&:not(:last-child)': {
			borderBottom: '1px solid #f1f3f5',
		},
	},
}));

const SERVER = basic.server;

const OperJoin: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();
	const { enqueueSnackbar } = useSnackbar();

	const [email, setEmail] = useState<string>('');
	const [emailAuth, setEmailAuth] = useState<boolean>(false);
	const [password, setPassword] = useState<string>('');
	const [passwordRe, setPasswordRe] = useState<string>('');
	const [check, setCheck] = useState<boolean>(false);
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [name, setName] = useState<string>('');
	const [phone, setPhone] = useState<string>('');
	const [affiliation, setAffiliation] = useState<string | null>(null);
	const buttonText = ['ID 중복 확인하기', 'ID 인증 완료!'];

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value, id } = e.target;
		if (id === 'email') {
			setEmail(value);
			setEmailAuth((prevState) => false);
		} else if (id == 'password') {
			setPassword(value);
			if (passwordRe == value) setCheck((prevState) => true);
			else setCheck((prevState) => false);
		} else if (id == 'passwordRe') {
			setPasswordRe(value);
			if (password == value) setCheck((prevState) => true);
			else setCheck((prevState) => false);
		} else if (id === 'name') setName(value);
		else if (id === 'phone') setPhone(value);
	};

	const handleClickShowPassword = () => {
		setShowPassword((prevState) => !prevState);
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	const getEmailAuth = () => {
		let url = new URL(SERVER + v_oper.oper + v_oper.auth_app_info);
		let params = { email: email ? email.toString().trim() : '' };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					console.log('setAuth');
					setEmailAuth((prevState) => true);
				} else if (data.code == Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.EMAIL_DUPLICATION, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
					setEmailAuth((prevState) => false);
				}
			});
	};

	const getJoin = () => {
		axios({
			method: 'POST',
			withCredentials: true,
			data: {
				email: email,
				pwd: password,
				name: name,
				phone: phone,
				affiliation: affiliation,
			},
			url: SERVER + v_oper.oper + v_oper.join,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar(ToastStr.JOIN_SUCCESS_STR, {
						variant: 'success',
						autoHideDuration: SNACKBAR_TIME,
					});
					history.push({
						pathname: '/operation',
					});
				} else {
					if (data.code == Values.FAIL_CODE) {
						enqueueSnackbar(ToastStr.JOIN_FAIL_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
					}
				}
			});
	};

	const handleEmailButton = (e: any) => {
		if (!emailAuth) {
			if (email.length == 0) {
				enqueueSnackbar(ToastStr.EMAIL_ADDR_CHECK_STR, {
					variant: 'warning',
					autoHideDuration: SNACKBAR_TIME,
				});
			} else if (email.length > 32) {
				enqueueSnackbar(ToastStr.EMAIL_ADDR_CHECK_LEN, {
					variant: 'warning',
					autoHideDuration: SNACKBAR_TIME,
				});
			} else {
				getEmailAuth();
			}
		}
	};
	const handleAuthButton = (e: any) => {
		if (!emailAuth) {
			enqueueSnackbar(ToastStr.EMAIL_AUTH_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		} else if (!affiliation) {
			enqueueSnackbar(ToastStr.AFFILIATION_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		} else if (password.length < 6 || password.length > 20) {
			enqueueSnackbar(ToastStr.PWD_ET_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		} else if (!check) {
			enqueueSnackbar(ToastStr.PWD_CHECK_FALSE_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
			setPasswordRe('');
		} else if (name.length < 2 || name.length > 10) {
			enqueueSnackbar(ToastStr.NAME_ET_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
			return false;
		} else if (phone.length < 11) {
			enqueueSnackbar(ToastStr.PHONE_ET_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
			return false;
		} else {
			getJoin();
		}
	};

	return (
		<div className={classes.background}>
			<Container component="main" className={classes.container}>
				<IconButton className={classes.back} onClick={() => history.goBack()}>
					<SIcon type="Back" />
				</IconButton>
				<div className={classes.paper}>
					<div className={classes.title}>
						<Typography variant="h6" style={{ color: `${COLORS.WATER_BLUE}` }}>
							플레이 스타트업에
						</Typography>
						<Typography variant="h6" style={{ color: `${COLORS.WATER_BLUE}` }}>
							오신 것을 환영합니다!
						</Typography>
					</div>

					<div className={classes.form}>
						{/* Email */}
						<TextField
							variant="standard"
							margin="normal"
							required
							fullWidth
							id="email"
							label="ID를 입력하세요."
							name="email"
							autoComplete="email"
							autoFocus
							InputProps={{ style: { fontSize: '4vw' } }}
							InputLabelProps={{ style: { fontSize: '3vw' } }}
							value={email}
							onChange={valueChangeHandler}
							style={{ color: `${COLORS.charcoal_grey}` }}
						/>

						<Button type="submit" fullWidth variant="contained" className={classes.submit} onClick={handleEmailButton}>
							{emailAuth && (
								<Check
									style={{
										marginRight: '2vw',
										color: `${COLORS.WHITE}`,
									}}
								/>
							)}
							<Typography variant="h3">{emailAuth ? buttonText[1] : buttonText[0]}</Typography>
						</Button>

						<TextField
							className={`${classes.selectField} ${classes.selectRoot}`}
							//variant="outlined"
							label="소속 선택"
							select
							fullWidth
							value={affiliation}
							InputLabelProps={{ shrink: true, className: classes.selectLabel }}
							onChange={(e) => setAffiliation((e.target as HTMLInputElement).value)}
							SelectProps={{
								MenuProps: {
									getContentAnchorEl: null,
									anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
									transformOrigin: { vertical: 'top', horizontal: 'left' },
									classes: { paper: classes.menuPaper },
								},
							}}
						>
							<MenuItem className={classes.menuItem} value="유스타터">
								유스타터
							</MenuItem>
							<MenuItem className={classes.menuItem} value="대구행복한미래재단">
								대구행복한미래재단
							</MenuItem>
							<MenuItem className={classes.menuItem} value="교사">
								교사
							</MenuItem>
							<MenuItem className={classes.menuItem} value="글로벌 사업">
								글로벌 사업
							</MenuItem>
						</TextField>

						{/* Password */}

						<FormControl fullWidth>
							<InputLabel style={{ fontSize: '3vw' }} htmlFor="filled-adornment-password">
								비밀번호를 입력하세요
							</InputLabel>
							<Input
								id="password"
								fullWidth
								type={showPassword ? 'text' : 'password'}
								value={password}
								onChange={valueChangeHandler}
								style={{ fontSize: '4vw' }}
								endAdornment={
									<InputAdornment position="end">
										<IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
											{showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								}
							/>
						</FormControl>

						<TextField
							variant="standard"
							margin="normal"
							fullWidth
							id="passwordRe"
							label="비밀번호를 다시 입력하세요"
							name="password"
							type="password"
							InputProps={{ style: { fontSize: '4vw' } }}
							InputLabelProps={{ style: { fontSize: '3vw' } }}
							value={passwordRe}
							onChange={valueChangeHandler}
							style={{ color: `${COLORS.charcoal_grey}` }}
						/>

						{/* Personal Info */}

						<TextField
							variant="standard"
							margin="normal"
							required
							fullWidth
							id="name"
							label="이름을 입력하세요."
							name="name"
							autoComplete="name"
							value={name}
							InputProps={{ style: { fontSize: '4vw' } }}
							InputLabelProps={{ style: { fontSize: '3vw' } }}
							onChange={valueChangeHandler}
							style={{ color: `${COLORS.charcoal_grey}` }}
						/>
						<TextField
							variant="standard"
							margin="normal"
							required
							fullWidth
							name="phone"
							label="휴대폰 번호를 입력하세요."
							id="phone"
							autoComplete="phone"
							value={phone}
							InputProps={{ style: { fontSize: '4vw' } }}
							InputLabelProps={{ style: { fontSize: '3vw' } }}
							onChange={valueChangeHandler}
							style={{ color: `${COLORS.charcoal_grey}` }}
						/>
						<Button type="submit" fullWidth variant="contained" className={classes.submit} onClick={(e) => handleAuthButton(e)}>
							<Typography variant="h3">선생님 회원가입하기</Typography>
						</Button>
					</div>
				</div>
			</Container>
		</div>
	);
};

export default OperJoin;
